import {cn} from '@/lib/utils';

export default function ChipSerif({
  text,
  className = '',
}: {
  text: string;
  className?: string;
}) {
  if (!text) return null;

  return (
    <p
      className={cn(
        'text-black/70 text-[2.25rem] font-instrument mb-[1.5rem]',
        className
      )}
    >
      {text}
    </p>
  );
}
